import { render, staticRenderFns } from "./VendorAnalstDashboard.vue?vue&type=template&id=791c8f76&scoped=true"
import script from "./VendorAnalstDashboard.vue?vue&type=script&lang=js"
export * from "./VendorAnalstDashboard.vue?vue&type=script&lang=js"
import style0 from "./VendorAnalstDashboard.vue?vue&type=style&index=0&id=791c8f76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791c8f76",
  null
  
)

export default component.exports